module.exports = __webpack_public_path__ + "img/chicken-top-corner.43c45d89.svg";